import React from 'react';
import Navbar from '../components/Navbar';
import HeroSection from '../components/HeroSection';
import GlobalStatsChart from '../components/GlobalStatsChart';
import FeaturesSection from '../components/FeaturesSection';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-[#fafafa]">
      <Navbar />
      <HeroSection />
      <GlobalStatsChart />
      <FeaturesSection />
      <Footer />
    </div>
  );
};

export default HomePage;
